<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      <div class="select-header-inner">
        {{ curPayType.name }}
        <a
          v-if="showDeleteIco"
          @click="save"
          class="edit-btn j-save-card-btn"
          href="javascript:;"
          >{{ letter.save }}</a
        >
        <a
          v-else
          @click="edit"
          class="edit-btn j-edit-card-btn"
          href="javascript:;"
          >{{ letter.edit }}</a
        >
      </div>
    </template>
    <template slot="select-content">
      <List class="card-select-container j-card-select-container">
        <ListItem
          class="select-items"
          type="paymentItem"
          pointClass="j-select-card"
          :active="card.KEY_VALUE == curCard.KEY_VALUE"
          @click="selectCard(card)"
          v-for="(card, index) in cardInfos"
          :key="card.KEY_VALUE"
        >
          {{ card.KEY_VALUE_DESC }}
          <em
            class="delete-ico j-delete-card-btn"
            v-if="showDeleteIco"
            @click.stop="deleteCard(card.KEY_VALUE)"
          ></em>
        </ListItem>
        <ListItem
          class="select-items"
          type="paymentItem"
          pointClass="j-select-new-card"
          :active="!curCard.KEY_VALUE"
          @click="useNewCard"
        >
          {{ letter.quickcard_use_new_card }}
        </ListItem>
      </List>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialStore/selectContainer';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
export default {
  name: 'QuickPayCardSelecter',
  mixins: [selectContainer],
  data() {
    return {
      showDeleteIco: false,
      confirmDelete: false
    };
  },
  props: ['curPayType', 'cardInfos', 'curCard'],
  methods: {
    selectCard(card) {
      this.$emit('selectCard', card);
    },
    edit() {
      this.showDeleteIco = true;
    },
    save() {
      this.showDeleteIco = false;
    },
    deleteCard(keyValue) {
      clickButton({
        btnName: 'delete_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('deleteCard', keyValue);
    },
    useNewCard() {
      clickButton({
        btnName: 'add_new_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('selectCard', {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';

.select-header-inner {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.edit-btn {
  width: 160px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  color: var(--channel-popup-btn);
  background-color: var(--channel-popup-btn-bg);
}
.select-items {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  .delete-ico {
    float: right;
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url($pnsImg + 'delete.png');
  }
}
</style>
